import {MeshCellValueFormat} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/MeshCellValueFormat';
import {AnySlot} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {SlotUtil} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotUtil';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {AString} from '@mintdata/mint-kit/api/values/AString';

export class TopFormulaEditorController
{
    public getActiveCellFormula():string
    {
        const {main, tabs, mesh, formulaInput, workbook, sheetSettings} = controllers.ui.spreadsheets;

        const empty = '';
        const rootWorkbook = main.getRootWorkbook();

        if( !rootWorkbook ) return empty;

        const activeSheet = tabs.getActiveSheet(rootWorkbook.id);
        const ctx:IWSPMeshContext = workbook.getMeshContextBySheetId(activeSheet.id);
        const meshState = mesh.getState(ctx);

        const activeCell = meshState.details.activeCell;

        if( !activeCell ) return empty;

        let result:string = empty;
        const cellFormat = sheetSettings.getCellFormat(activeSheet.id, activeCell.asKey());
        if( main.isEditMode )
        {
            const {colIndex, rowIndex, formulaTokens} = main.getEditorState().input;

            result = formulaInput.getFormulaTokensText(formulaTokens, colIndex, rowIndex, true);
        }
        else
        {
            const slot:AnySlot = ctx.sheetCtrl.findSlot(ctx.sheetId, activeCell.toSlotLocation());

            if( slot )
            {
                if( slot.formula === null )
                {
                    if( cellFormat )
                    {
                        result = cellFormat.formatValue(slot.value);
                    }
                    else
                    {
                        result = slot.value.toString();
                    }
                }
                else if( SlotUtil.isIValue(slot.formula) )
                {
                    if( Type.isInstanceOf(slot.formula, Type.Frame) )
                    {
                        result = '<Frame>';
                    }
                    else if( cellFormat )
                    {
                        result = cellFormat.formatValue(slot.value);
                    }
                    else
                    {
                        result = slot.value.toString();
                    }
                }
                else
                    result = mesh.convertR1C1toA1(slot.formula, slot.location) as string;
            }
        }

        const cellSettings = sheetSettings.getCellSettings(activeSheet.id, activeCell.asKey());

        if( cellSettings && cellSettings.isValueMasked )
        {
            return MeshCellValueFormat.MaskedText.formatValue(AString.fromString(result));
        }
        return result;
    }
}
